import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Card,
  CardContent,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';

const FaqHeader = ({
  searchQuery,
  setSearchQuery,
  handleSearch,
  handleClear,
  handleKeyPress,
  sortOrder,
  handleSortOrderChange,
  handleBatchUpload,
  handleCreate,
  voiceEnabled = false,
  handleBulkRegenAudio
}) => {
  return (
    <Box sx={{ 
      flexShrink: 0,
      backgroundColor: '#f5f5f5',
      borderBottom: '1px solid #e0e0e0',
      p: 3,
      pb: 2
    }}>
      {/* Title */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
          常見問題管理
        </Typography>
      </Box>
      
      {/* Search Card */}
      <Card elevation={2}>
        <CardContent sx={{ py: 2 }}>
          <Grid container spacing={2} alignItems="center" justifyContent="space-between">
            {/* Left side: Search Input and Search/Clear buttons */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={2} alignItems="center">
                {/* Search Input */}
                <Grid item xs={12} sm={7}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="搜尋問題、回答、分類或關鍵詞"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyPress={handleKeyPress}
                    size="medium"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                
                {/* Search Button */}
                <Grid item>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleSearch}
                    sx={{ 
                      height: 40,
                      minWidth: 'unset',
                      px: 2
                    }}
                  >
                    <SearchIcon sx={{ mr: 0.5 }} fontSize="small" />
                    搜尋
                  </Button>
                </Grid>
                
                {/* Clear Button */}
                <Grid item>
                  <Button 
                    variant="outlined" 
                    color="secondary" 
                    onClick={handleClear}
                    sx={{ 
                      height: 40,
                      minWidth: 'unset',
                      px: 2
                    }}
                  >
                    <ClearIcon sx={{ mr: 0.5 }} fontSize="small" />
                    重設
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            
            {/* Right side: Sort toggle, Batch Upload and Add New buttons */}
            <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
              <Stack direction="row" spacing={2} alignItems="center">
                {/* Sort Order Toggle */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                    排序:
                  </Typography>
                  <ToggleButtonGroup
                    value={sortOrder}
                    exclusive
                    onChange={handleSortOrderChange}
                    aria-label="排序方式"
                    size="small"
                  >
                    <ToggleButton value="asc" aria-label="升序" title="升序">
                      <ArrowUpwardIcon fontSize="small" />
                      <Typography variant="caption" sx={{ ml: 0.5, display: { xs: 'none', sm: 'inline' } }}>
                        升序
                      </Typography>
                    </ToggleButton>
                    <ToggleButton value="desc" aria-label="降序" title="降序">
                      <ArrowDownwardIcon fontSize="small" />
                      <Typography variant="caption" sx={{ ml: 0.5, display: { xs: 'none', sm: 'inline' } }}>
                        降序
                      </Typography>
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
                
                {/* Bulk Regenerate Audio (Plan 068 Day 4 — voice plan only) */}
                {voiceEnabled && handleBulkRegenAudio && (
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<GraphicEqIcon />}
                    onClick={handleBulkRegenAudio}
                    sx={{ height: 40 }}
                  >
                    批次產生語音
                  </Button>
                )}

                {/* Batch Upload Button */}
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<UploadFileIcon />}
                  onClick={handleBatchUpload}
                  sx={{ height: 40 }}
                >
                  批次上傳
                </Button>
                
                {/* Add New Button */}
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddCircleIcon />}
                  onClick={handleCreate}
                  sx={{ height: 40 }}
                >
                  新增問題
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FaqHeader;